import axios from 'axios'
//axios解决跨域cookie丢失问题
//axios.defaults.withCredentials = true;
// 不想在每次请求都设置的话，可以集中设置下
axios.defaults.headers.post['Content-Type'] = 'application/json; charset=UTF-8';
export default axios.create({
    baseURL: '',
    timeout: 10000
})


// WEBPACK FOOTER //
// ./src/api/index.js